export const settings = {
    state: {
        status: 'idle',
        settings: {}
    },
    mutations: {
        SET_SETTINGS_STATUS(state, status) {
            state.status = status
        },
        SET_SETTINGS(state, settings) {
            state.settings = settings
        },
        SET_SETTINGS_FIELD(state, payload) {
            this.$vue.set(state.settings, payload.name, payload.value)
        }
    },
    actions: {
        fetchSettings({ state, commit }, payload) {
            commit('SET_SETTINGS', null)
            commit('SET_SETTINGS_STATUS', 'loading')
            return this.$api.get('api/settings.json').then(response => {
                commit('SET_SETTINGS', response.data.data)
                commit('SET_SETTINGS_STATUS', 'idle')
            }).catch(error => {
                commit('SET_SETTINGS_STATUS', 'error')
                return Promise.reject(error)
            })
        },
        saveSettings({ state, commit }, payload) {
            commit('SET_SETTINGS_STATUS', 'saving')
            return new Promise((resolve, reject) => {
                return this.$api.put('api/settings.json', state.settings).then(response => {
                    if(response.data.message === 'ok') {
                        commit('SET_SETTINGS_STATUS', 'idle')
                        resolve()
                    } else {
                        reject(new Error('API Error'))
                    }
                }).catch(error => {
                    commit('SET_SETTINGS_STATUS', 'error')
                    reject(error)
                })
            })
        },
        setSettingsField({ state, commit }, payload) {
            commit('SET_SETTINGS_FIELD', payload)
        }
    },
    getters: {
        settingsStatus: (state) => {
            return state.status
        },
        settings: (state) => {
            if(state.settings) {
                return state.settings
            }
        }
    }
}
